import {
    Alert,
    Box,
    Button,
    Checkbox, CircularProgress,
    Container,
    Divider,
    FormControlLabel, FormGroup, FormLabel,
    Grid,
    Link,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";

import {
    CardCvcElement,
    CardElement, CardExpiryElement,
    CardNumberElement,
    Elements,
    PaymentElement,
    useElements,
    useStripe
} from '@stripe/react-stripe-js';
import {
    ConfirmCardPaymentData,
    CreatePaymentMethodData,
    loadStripe,
    SetupIntentConfirmParams, Stripe,
    StripeCardElement
} from '@stripe/stripe-js';
import {useNavigate} from "react-router";
import {useBasketContext, useBasketDataContext} from "../Contexts/BasketContext";
import {useCreatePaymentMethodMutation, useInitiatePaymentMutation} from "../generated/graphql";
import FullWait from "../Components/FullWait";
import {useSiteDataContext} from "../Contexts/SiteDataContext";
import StripeInput from "../Components/StripeInput";
import {useUserDataContext} from "../Contexts/UserContext";

//const stripePromise = loadStripe('pk_test_51L99JnH1pvDhlbVFm2rr6w7dR6FlpKNt2xWuqIBUGDDWtnRSz0ovmnVdFy8vTDBs3hVpTU3b41a7yh1eQ7DXa8Iv00MUnyv6io');


function PaymentPage() {
    const [stripePromise,setStripePromise] = useState<Promise<Stripe|null>|null>(null);
    const siteData = useSiteDataContext();
    useEffect(()=>{
        if(!siteData || !siteData?.siteData?.stripePublicKey) return;
        if(stripePromise) return;
        setStripePromise(loadStripe(siteData?.siteData?.stripePublicKey));
    },[siteData?.siteData?.stripePublicKey]);
    return (<Elements stripe={stripePromise}>
        <PaymentForm/>
    </Elements>);
}


function PaymentForm() {
    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();
    const [isSubmitting,setIsSubmitting] = useState(false);
    const [error,setError] = useState('');
    const [confirmed,setConfirmed] = useState(false);
    const basketData = useBasketDataContext();
    const basketSetter = useBasketContext();
    const siteData = useSiteDataContext();
    const page = siteData?.pages?.payment;
    const userData = useUserDataContext();
    const [initiatePayment,execInitiatePayment] = useInitiatePaymentMutation();
    const [createPaymentMethod,execCreatePaymentMethod] = useCreatePaymentMethodMutation();

    useEffect(()=>{
        if(!basketData) return;
        // TODO: re-enable this!
        if(!basketData.customer) {
            navigate('/');
        }
        if(!basketData.subscription) {
            navigate('/select-membership');
        }
    },[basketData]);
    useEffect(()=>{
        if(!basketData?.customer?.token) return;
        if(!basketData?.subscription?.code) return;
        if(!siteData?.siteData?.subdomain) return;
        execInitiatePayment({productCode:basketData.subscription.code,token:userData.token,theatre:siteData?.siteData?.subdomain,
        customerToken:basketData?.customer?.token}).then(
            (data)=>{
                if(data.error||!data?.data?.initiatePayment) {
                    // TODO: this
                } else {
                    basketSetter.setPaymentIntent(data.data.initiatePayment);
                }
            }
        );
    },[basketData?.customer?.token,basketData?.subscription?.code,userData?.token]);
    function toggleConfirm() {
        setConfirmed((v)=>!v);
    }
    const handleSubmit = async (event:any) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        setIsSubmitting(true);
        const cardElement = elements.getElement(CardNumberElement);
        if(basketData?.paymentIntent?.resultType=='paymentMethod') {
            // eekies.
            // create a paymentmethod (token)
            // send the token to our server to create a setupIntent
            // confirm the setupIntent
            const args:CreatePaymentMethodData = {
                type:'card',
                card: cardElement!
            };
            if(basketData?.customer?.postcode) {
                args.billing_details = {address:{postal_code:basketData?.customer?.postcode}};
            }
            const pmResult = await stripe.createPaymentMethod(args);
            if(pmResult.error) {
                setError(pmResult.error.message??'');
                return;
            }
            console.log('pmResult',pmResult);
            const cpResult = await execCreatePaymentMethod({productCode:basketData!.subscription!.code,token:userData!.token,theatre:siteData?.siteData?.subdomain,
                customerToken:basketData?.customer?.token,paymentMethod:pmResult.paymentMethod.id});
            if(!cpResult?.data?.createPaymentMethod) {
                setError('Unable to contact Server, please try again later');
                return;
            }
            if(cpResult?.data?.createPaymentMethod.error) {
              setError(cpResult?.data?.createPaymentMethod.error);
              return;
            }
            console.log('result',cpResult);

            // the setup intent is attached to a confirmed subscription behind the scenes, and then
            /*
            const {error} = await stripe.confirmCardPayment(cpResult?.data?.createPaymentMethod?.clientSecret??'',
            //const {error} = await stripe.confirmCardSetup(cpResult?.data?.createPaymentMethod?.clientSecret??'',
            {
                return_url: 'https://'+document.location.hostname+'/complete'
                }
            );
            if(error) {
                setError(error.message??'An error has occurred');
            } else {
                navigate('/complete');
            }
            */
            setIsSubmitting(false);
            navigate('/complete');
            return;
        }
        const args:ConfirmCardPaymentData = {
            //`Elements` instance that was used to create the Payment Element
            payment_method: {
                card: cardElement!,
                billing_details: {
                    address:{
                        postal_code:basketData?.customer?.postcode??''
                    }
                }
            },
            return_url: 'https://'+document.location.hostname+'/complete'
        };
        const result = await stripe.confirmCardPayment(basketData?.paymentIntent?.clientSecret??'', args);
        setIsSubmitting(false);
        if (result.error) {
            setError(result.error.message??'');
        } else {
            navigate('/complete');
        }
    };
    if((!initiatePayment.data?.initiatePayment && initiatePayment.fetching) || !basketData) {
        return <FullWait/>;
    }
    if(initiatePayment.data?.initiatePayment?.error) {
        return <Alert severity="error">Unable to initiate payment screen</Alert>;
    }
    const formatter = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    function priceAsPounds(price) {
        return formatter.format(price/100);
    }
    /*
    if(initiatePayment.error) {
        return <Alert severity="error">We are currently unable to process your order, please try again later</Alert>;
    }*/
    /*function doSubmit(evt) {
        evt.preventDefault();
        const result = stripe.confirmCardPayment(initiatePayment.data?.initiatePayment?.clientSecret, {
            elements
        });
        console.log('got',result);
        if (result.error) {
            setError(result.error);
        }
        //navigate('/complete')

    }*/
    return (
            <Container maxWidth="md">
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Typography typography="h1" color="primary">{page.title}</Typography>
                        <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                        <Divider sx={
                            (theme) => ({
                                paddingTop: theme.spacing(4)
                            })}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <FormLabel>
                                    Order summary
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography typography="h6">
                                    {basketData?.subscription?.name??''}
                                </Typography>
                                <Typography typography="body2">
                                    {basketData?.subscription?.description??''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormLabel>
                                    Member email
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography typography="p">
                                    {basketData?.customer?.email??''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormLabel>
                                    {page.totalLabel}
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography typography="p">
                                    {priceAsPounds(basketData?.subscription?.price??'')}
                                </Typography>
                            </Grid>                        </Grid>
                        <form onSubmit={handleSubmit}>
                            <Box sx={(theme)=>({paddingTop:theme.spacing(2),paddingBottom:theme.spacing(2)})}>
                            <FormLabel>Payment details:</FormLabel>
                                {error!='' &&
                                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{error}</Alert>
                                }
                                <Box sx={(theme)=>({paddingTop:theme.spacing(2),paddingBottom:theme.spacing(2)})}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Credit Card Number"
                                        name="ccnumber"
                                        variant="standard"
                                        required
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                              inputComponent: StripeInput,
                                              inputProps: {
                                                component: CardNumberElement
                                            }}
                                        }
                                    /></Grid>
                                        <Grid item xs={6} md={4}>
                                    <TextField
                                        label="Expiration Date"
                                        name="ccexp"
                                        variant="standard"
                                        required
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: StripeInput,
                                            inputProps: {
                                                component: CardExpiryElement
                                            },
                                        }}
                                    /></Grid>
                                        <Grid item xs={6} md={2}>
                                    <TextField
                                        label="CVC"
                                        name="cvc"
                                        variant="standard"
                                        required
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: StripeInput,
                                            inputProps: {
                                                component: CardCvcElement
                                            },
                                        }}
                                    /></Grid>
                                    </Grid>
                                    {/*
                                    <CardElement options={{value:{postalCode:basketData?.customer?.postcode??''}}}/>
                                    */}
                                </Box>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox checked={confirmed} onChange={toggleConfirm}/>} label={page.termsLabel}/>
                                <Button color="secondary"
                                        startIcon={isSubmitting?<CircularProgress size="1rem"/>:null}
                                        variant="contained" disabled={!stripe || !confirmed||isSubmitting} onClick={handleSubmit}>{page.button}</Button>
                            </FormGroup>
                            </Box>
                        </form>
                    </Grid>
                </Grid>
            </Container>
    );
}

export default PaymentPage;